import PropTypes from 'prop-types';
import React from 'react';

import CommonDialog from './CommonDialog';

const ConfirmationDialog = props => {
    const { open, handleClose, disableButtonSave, isLoading, t } = props;

    let { TitleButtomOk, TitleButtomCancel, title, description, handleOk } = props;

    if (TitleButtomOk === '' || TitleButtomOk === undefined) {
        TitleButtomOk = 'ok';
    }

    if (TitleButtomCancel === '' || TitleButtomCancel === undefined) {
        TitleButtomCancel = 'cancel';
    }

    if (title === '' || title === undefined) {
        title = 'Confirmation';
    }

    if (description === '' || description === undefined) {
        description = 'Are you sure?';
    }

    if (handleOk === undefined) {
        handleOk = handleClose;
    }

    const actions = [
        {
            translateId: TitleButtomCancel,
            onClick: handleClose,
            type: 'cancel'
        },
        {
            color: 'secondary',
            translateId: TitleButtomOk,
            onClick: handleOk,
            type: 'submit',
            variant: 'contained',
        }
    ];

    return (
        <CommonDialog
            onClose={handleClose}
            open={open}
            title={title}
            actions={actions}
            disableButtonSave={disableButtonSave}
            isLoading={isLoading}
            t={t}
        >
            {description}
        </CommonDialog>
    );
};

ConfirmationDialog.propTypes = {
    handleClose: PropTypes.func.isRequired,
    handleOk: PropTypes.func.isRequired,
    open: PropTypes.bool,
    description: PropTypes.node,
    title: PropTypes.node,
    TitleButtomOk: PropTypes.string,
    TitleButtomCancel: PropTypes.string,
};

export default ConfirmationDialog;
